import React from 'react'
import styles from './styles'
import IconLogo from './law'

const Logo = ({ matches }) => {
	const { lawIcon, navHeader, header, subHeader } = styles[
		matches ? 'sm' : 'lg'
	]

	return (
		<div style={styles.container}>
			<IconLogo style={lawIcon} />
			<div style={navHeader}>
				<div style={header}>Robert A. Hacker</div>
				<div style={subHeader}>Attorney at Law + Sports Media Consulting</div>
			</div>
		</div>
	)
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/Layout/Logo/index.js